import { isAfter } from 'date-fns'
import { IStore } from '../../index'

export function isUserLoading(state: IStore) {
  return state.userAccount.request.isLoading
}

export function getUser(state: IStore) {
  return state.userAccount.user && state.userAccount.user
}

export function getUserId(state: IStore) {
  return state.userAccount.user && state.userAccount.user.id
}

export function getUserPollDisplayed(state: IStore) {
  return state.userAccount.user && state.userAccount.user.poll_displayed
}

export function getUserCookiesOpen(state: IStore){
  return state.userAccount.cookies.open
}
export function getUserCookiesForce(state: IStore){
  return state.userAccount.cookies.forceSave
}

export function getUserCookiesStep(state: IStore){
  return state.userAccount.cookies.step
}

export function getUserPriceGroup(state: IStore) {
  return state.userAccount.user.userPriceGroup
}

export function isUserNewPremium(state: IStore) {
  return (
    state.userAccount.user.userPriceGroup === '1' ||
    state.userAccount.user.userPriceGroup === '2'
  )
}

export function isUserNewPackage(state: IStore) {
  return (
    state.userAccount.user.userPriceGroup === '3'
  )
}

export function getUserEmail(state: IStore) {
  return state.userAccount.user && state.userAccount.user.email
}

export function getUsername(state: IStore) {
  return state.userAccount.user && state.userAccount.user.email
}

export function getUserLanguage(state: IStore) {
  return state.userAccount.user && state.userAccount.user.savedLanguage
}

export function getUserPremiumUsed(state: IStore) {
  return state.userAccount.user && state.userAccount.user.promotionUsed
}

export function getBookingPropertyId(state: IStore) {
  return state.userAccount.user.booking_property_id
}

export function getBookingPropertyStatus(state: IStore) {
  return (
    state.booking.settings && state.booking.settings.booking_integration_status
  )
}

export function getDeleteAccountError(state: IStore) {
  return state.userAccount.deleteError
}

export function isWorker(state: IStore) {
  return !!state.userAccount.user.id_worker
}

export function getWorkerId(state: IStore) {
  return state.userAccount.user.id_worker
}

export function getOwnerId(state: IStore) {
  return state.userAccount.user.id_owner
}

export function getUserScope(state: IStore) {
  return state.userAccount.user.scopes
}

export function isNewAccount(state: IStore) {
  return (
    state.userAccount.user &&
    isAfter(
      state.userAccount.user.createDate,
      state.userAccount.user.newUserDate,
    )
  )
}
